import React from "react";
import { Button } from "reactstrap";

export const StockClearFooter = ({ onConfirm, disabled }) => (
  <Button
    style={{ width: "100%", margin: 0 }}
    color="info"
    data-dismiss="modal"
    type="button"
    onClick={onConfirm}
    disabled={disabled}
  >
    Limpar estoque
  </Button>
);
